import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaRedoAlt } from "react-icons/fa";
// Light web version of assets/offline.png (1600 px wide).
import offlineImage from "../assets/offline.webp";
import { useHideParentNavbar } from "../portals/parent/parentChrome";

/** Seconds between automatic retries. */
export const AUTO_RETRY_SECONDS = 180;

const PPErrorPage = ({ message, status, onRetry }) => {
    const { t } = useTranslation();
    useHideParentNavbar();
    // Try again by itself every 3 minutes, so a parent does not have to keep pressing the button.
    const [secondsLeft, setSecondsLeft] = useState(AUTO_RETRY_SECONDS);
    useEffect(() => {
        const timer = window.setInterval(() => setSecondsLeft((current) => Math.max(0, current - 1)), 1000);
        return () => window.clearInterval(timer);
    }, []);
    useEffect(() => {
        if (secondsLeft === 0) {
            onRetry?.();
            setSecondsLeft(AUTO_RETRY_SECONDS);
        }
    }, [secondsLeft, onRetry]);
    const countdown = `${Math.floor(secondsLeft / 60)}:${String(secondsLeft % 60).padStart(2, "0")}`;
    void message;
    void status;

    return (
        // Same width as the top bar of the parent portal, so their edges line up.
        <div className="mt-6 w-full px-4 sm:px-0 lg:mt-10">
            <div className="relative overflow-hidden rounded-2xl border border-white/30 bg-white/60 text-left shadow-lg backdrop-blur-md transition supports-[backdrop-filter]:bg-white/30 dark:border-white/10 dark:bg-gray-800/50 dark:supports-[backdrop-filter]:bg-gray-800/30">
                <img
                    src={offlineImage}
                    alt=""
                    aria-hidden="true"
                    className="block h-44 w-full object-cover object-[60%_55%] sm:h-60 lg:h-72"
                />
                <div className="p-6 sm:p-8">
                    <div className="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-br from-white/55 via-white/15 to-transparent dark:from-gray-800/70 dark:via-gray-800/25 dark:to-transparent" />
                    <div className="pointer-events-none absolute inset-0 -z-20 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.35),_transparent_60%)] dark:bg-[radial-gradient(circle_at_top,_rgba(17,24,39,0.55),_transparent_60%)]" />
                    <h1 className="mb-3 text-xl font-semibold text-[#4a7a85] dark:text-[#9cc4cc] md:text-2xl">
                        {t("parentPortal.error.title")}
                    </h1>
                    <p className="mb-3 max-w-2xl text-base leading-6 text-gray-700 dark:text-gray-200">
                        {t("parentPortal.error.message")}
                    </p>
                    <p className="mb-5 max-w-2xl text-sm leading-6 text-gray-600 dark:text-gray-300">
                        {t("parentPortal.error.explanation")}
                    </p>
                    <button
                        onClick={onRetry}
                        className="inline-flex items-center justify-center gap-2 rounded-full bg-[#4a7a85] px-5 py-2.5 text-sm font-semibold text-white shadow transition hover:bg-[#3c636d] focus:outline-none focus:ring-2 focus:ring-[#4a7a85]/40"
                    >
                        <FaRedoAlt className="h-4 w-4" aria-hidden="true" />
                        {t("parentPortal.error.retry")}
                    </button>
                    <p className="mt-3 text-xs text-gray-500 dark:text-gray-400" aria-live="off">
                        {t("parentPortal.error.auto_retry", { time: countdown, defaultValue: "We will try again automatically in {{time}}." })}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PPErrorPage;
